module.exports = __webpack_public_path__ + "img/SadikDs_02_02_26.ede95756.png";